/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsinvoicesellernone3Inputs */

const en_ticketsinvoicesellernone3 = /** @type {(inputs: Ticketsinvoicesellernone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not given yet`)
};

const de_ticketsinvoicesellernone3 = /** @type {(inputs: Ticketsinvoicesellernone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nicht angegeben`)
};

/**
* | output |
* | --- |
* | "Not given yet" |
*
* @param {Ticketsinvoicesellernone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsinvoicesellernone3 = /** @type {((inputs?: Ticketsinvoicesellernone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsinvoicesellernone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsinvoicesellernone3(inputs)
	return de_ticketsinvoicesellernone3(inputs)
});
export { ticketsinvoicesellernone3 as "ticketsInvoiceSellerNone" }